import { message } from 'antd';
import { head } from 'lodash';
import { isNotEmpty, parseUrlSearch } from './Utils';

class AuthFetchService {

    perms = {}

    allow(code) { return this.perms[code] === true; }

    prefix(code) {
        for (let perm of Object.keys(this.perms)) {
            if (perm.startsWith(code)) {
                return true;
            }
        }
        return false;
    }

    async authenticate() {
        const user = await this.get('/api/v1/user/info');
        if (user) {
            this.perms = {};
            for (let perm of user.flatPerms) {
                this.perms[perm] = true;
            }
            this.uid = user.uid;
        }
        return user;
    }

    appendLog(pageId, params) {
        this.post('/api/v1/user/access_log', {
            pageId: pageId,
            params: params
        }).then((_) => { })
    }

    async post(url, req) { return this.method("POST", url, req); }

    async put(url, req) { return this.method("PUT", url, req); }

    async method(way, url, req) {
        try {
            const params = parseUrlSearch(window.location.search);
            const headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            };
            if (isNotEmpty(params.access_token)) {
                headers['Cya-Datap-AK'] = params.access_token;
            }
            let response = await fetch(url, {
                method: way,
                body: req === undefined || req === null ? null : JSON.stringify(req),
                headers
            });
            this.handleError(response);
            if (response.headers.get('content-length') === '0' ||
                response.status !== 200) {
                return;
            }
            return await response.json();
        } catch (error) {
            console.error(way, url, error);
            throw error;
        }
    }

    async get(url) {
        try {
            const params = parseUrlSearch(window.location.search);
            const headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            };
            if (isNotEmpty(params.access_token)) {
                headers['Cya-Datap-AK'] = params.access_token;
            }
            let response = await fetch(url, {
                method: 'GET',
                headers
            });
            this.handleError(response);
            if (response.headers.get('content-length') === '0' ||
                response.status !== 200) {
                return;
            }
            return await response.json();
        } catch (error) {
            console.error('GET', url, error);
            throw error;
        }
    }

    handleError(response) {
        if (response.status === 401) {
            window.location.assign("https://cyamis.baicizhan.com/home/scan_to_login_weixin?redirect=https%3A%2F%2Fdatap.baicizhan.com");
        } else if (response.status === 403) {
            window.location.assign("/403.html");
        } else if (response.status === 500) {
            message.error('服务器内部故障，请联系开发人员。');
        } else if (response.status === 502) {
            message.error('服务器发布中，请稍后再试。');
        } else if (response.status === 200) {
            // OK!
        } else {
            message.error('服务错误：' + response.status);
        }
    }
}

export default new AuthFetchService();